// File: src/MathTools/PolyViewer.jsx
//------------------------------------------------------------
// Minimal polynomial visualiser: shows (poly)^power expanded.
// No external dependencies.
//------------------------------------------------------------
import React, { useMemo } from 'react';

/* ---------- 20-line standalone helper -------------------- */
class MiniPoly {
  // terms stored as Map<exponent, coefficient>
  constructor(str) {
    this.t = new Map();
    str.replace(/\s+/g, '').split('+').forEach(term => {
      let coef, exp;
      if (term.includes('x')) {
        const parts = term.split('x^');
        if (parts.length === 2) {
          coef = parts[0] === '' ? 1 : +parts[0];
          exp  = +parts[1];
        } else { // x or kx
          coef = term === 'x' ? 1 : +term.replace('x', '');
          exp  = 1;
        }
      } else { // constant term
        coef = +term;
        exp  = 0;
      }
      this.t.set(exp, (this.t.get(exp) || 0) + coef);
    });
  }
  multiply(b) {
    const out = new MiniPoly('0');
    out.t.clear();
    for (const [e1, c1] of this.t)
      for (const [e2, c2] of b.t)
        out.t.set(e1 + e2, (out.t.get(e1 + e2) || 0) + c1 * c2);
    return out;
  }
  pow(k) { let r = new MiniPoly('1'); for (let i = 0; i < k; i++) r = r.multiply(this); return r; }
  toString() {
    return [...this.t.entries()]
      .sort((a, b) => a[0] - b[0])
      .map(([e, c]) => `${c === 1 && e !== 0 ? '' : c}${e === 0 ? '' : e === 1 ? 'x' : 'x^' + e}`)
      .join(' + ');
  }
}
/* --------------------------------------------------------- */

export default function PolyViewer({ poly = 'x + x^2 + x^3', power = 2 }) {
  const expanded = useMemo(() => {
    const p = new MiniPoly(poly);
    const q = p.pow(power);
    return q.toString();
  }, [poly, power]);

  return (
    <pre style={{ background: '#f5f5f5', padding: 6 }}>
      ({poly})^{power} = {expanded}
    </pre>
  );
}
